<template>
  <div>
    <el-dialog
      :title="config.title"
      :visible.sync="config.visible"
      :class="config.type === 'detail' ? 'mid-dialog' : 'small-dialog'"
      :before-close="close"
    >
      <div>
        <el-form
          ref="operateForm"
          :model="operateForm"
          :rules="operateRules"
          label-width="150px"
          size="small"
        >
          <el-form-item label="序号" prop="seqNo">
            <el-input-number
              :disabled="config.type === 'detail'"
              class="w-280px"
              v-model="operateForm.seqNo"
              :min="0"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="场景名称" prop="sceneId">
            <el-select
              v-model="operateForm.sceneId"
              placeholder="请选择场景"
              filterable
              :disabled="config.type === 'detail'"
              class="w-full"
            >
              <el-option
                v-for="item in sceneList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预加载最少节点数" prop="preloadedMinNodes">
            <el-input-number
              :disabled="config.type === 'detail'"
              class="w-280px"
              v-model="operateForm.preloadedMinNodes"
              :min="0"
              :max="maxConnectCount"
              controls-position="right"
            ></el-input-number>
            <el-tooltip content="无人访问也保留的节点个数" effect="dark" placement="right">
              <i class="iconfont icon-bg-circleWarning text-14px ml-10px cursor-pointer"></i>
            </el-tooltip>
            <div class="text-12px mt-10px">
              云渲染节点共{{ maxConnectCount }}个，当前最多可配置{{ availableCount }}个
            </div>
          </el-form-item>
          <el-form-item label="预加载最多节点数">
            <el-input-number
              :disabled="config.type === 'detail'"
              class="w-280px"
              v-model="operateForm.preloadedMaxNodes"
              :min="0"
              :max="maxConnectCount"
              controls-position="right"
            ></el-input-number>
            <el-tooltip
              content="超出此个数后需临时加载模型，配置最大节点数≤总节点数"
              effect="dark"
              placement="right"
            >
              <i class="iconfont icon-bg-circleWarning text-14px ml-10px cursor-pointer"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="空闲节点">
            <el-input-number
              :disabled="config.type === 'detail'"
              class="w-280px"
              v-model="operateForm.freeTimeNodes"
              :min="0"
              :max="maxConnectCount - operateForm.preloadedMinNodes"
              controls-position="right"
            ></el-input-number>
            <el-tooltip
              content="当前预加载数量=使用节点+空闲节点，空闲节点≤总结点-最小节点数"
              effect="dark"
              placement="right"
            >
              <i class="iconfont icon-bg-circleWarning text-14px ml-10px cursor-pointer"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="状态" v-if="config.type !== 'detail'">
            <el-switch
              v-model="operateForm.isActive"
              :disabled="config.type === 'detail' || availableCount < operateForm.preloadedMinNodes"
              active-color="#13ce66"
            ></el-switch>
          </el-form-item>
        </el-form>
        <div class="text-20px font-bold" v-if="config.type === 'detail'">连接列表</div>
        <el-table
          v-if="config.type === 'detail'"
          class="mt-20px"
          :data="surveillanceData"
          v-loading="surveillanceLoading"
          highlight-current-row
          row-key="id"
          border
          max-height="352px"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
        >
          <el-table-column prop="engineId" label="引擎ID" show-overflow-tooltip></el-table-column>
          <el-table-column prop="clients" label="客户端" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="clusterId"
            label="所属集群节点"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="maxTimeout"
            label="超时设置(ms)"
            min-width="60px"
          ></el-table-column>
          <el-table-column prop="status" label="状态" min-width="50px"></el-table-column>
          <el-table-column prop="type" label="传输类型" min-width="50px"></el-table-column>
          <el-table-column prop="trueName" label="用户名称" min-width="50px"></el-table-column>
          <el-table-column label="操作" min-width="50px">
            <template slot-scope="{ row }">
              <a
                href="javascript:;"
                @click="forceTerminate(row)"
                class="text-blue-600"
                v-if="row.type && row.clusterId"
                >强制终止</a
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button type="primary" v-if="config.type !== 'detail'" @click="submitForm"
          >保 存</el-button
        >
        <el-button @click="close">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { CloudRenderNodesApi } from '@wiz-api/cloud-render-management'
import CloudProxyService from '../../services/CloudProxyService'

const cloudRenderNodesApi = new CloudRenderNodesApi()

export default {
  props: {
    config: {
      type: Object,
      defalut: () => {
        return {
          visible: false,
          title: '',
          type: '',
          data: null,
        }
      },
    },
    sceneList: {
      type: Array,
      defalut: () => {
        return []
      },
    },
    maxConnectCount: {
      type: Number,
      defalut: 0,
    },
    availableCount: {
      type: Number,
      defalut: 0,
    },
  },
  data() {
    return {
      operateForm: {
        isActive: false,
        seqNo: 0,
        sceneId: '',
        preloadedMinNodes: 0,
        preloadedMaxNodes: 0,
        freeTimeNodes: 0,
      },
      currentId: null,
      surveillanceData: [],
      surveillanceLoading: false,
      timer: null,
      operateRules: {
        seqNo: { required: true, message: '请输入序号', trigger: ['blur', 'change'] },
        sceneId: { required: true, message: '请选择场景', trigger: 'blur' },
        preloadedMinNodes: {
          required: true,
          message: '请输入预加载最少节点数',
          trigger: ['blur', 'change'],
        },
      },
    }
  },
  async created() {
    if (this.config.data) {
      this.operateForm = _.pick(this.config.data, [
        'isActive',
        'seqNo',
        'sceneId',
        'preloadedMinNodes',
        'preloadedMaxNodes',
        'freeTimeNodes',
      ])
      this.currentId = this.config.data.id
    }
    if (this.config.type === 'detail') {
      this.surveillanceLoading = true
      this.surveillanceData = await this.getConnectionList()
      this.surveillanceLoading = false
      // 开启定时器实时刷新列表
      this.timer = setInterval(async () => {
        this.surveillanceData = await this.getConnectionList()
      }, 2000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    // 强制终止连接
    async forceTerminate(row) {
      const [err, res] = await CloudProxyService.forceTerminate({
        id: row.engineId,
      })
      console.log(res, 11111111)
      if (!err && res && res.message === 'OK') {
        this.$message.success('终止成功')
        this.surveillanceData = await this.getConnectionList()
      } else {
        this.$message.error('终止失败')
      }
    },
    // 获取连接列表
    async getConnectionList() {
      const ipObj = {}
      // 获取客户端的ip
      const [error, result] = await CloudProxyService.getIP({ t: dayjs().valueOf() })
      if (!error) {
        const resData = result
        _.forIn(resData, (v, k) => {
          ipObj[k] = v.ip.split('::ffff:')[1]
        })
      }
      const resArr = []
      const [err, res] = await CloudProxyService.getNodeConnectionList({
        id: this.operateForm.sceneId,
      })
      if (!err && res && res.data) {
        const resData = res.data
        // 格式化数据
        _.forEach(resData, (v) => {
          v.clients = _.keys(v.clients)[0]
          v.clients && (v.clients = `${v.clients}@${ipObj[v.clients]}`)
          resArr.push(v)
        })
      }
      return resArr
    },
    // 提交表单
    submitForm() {
      this.$refs.operateForm.validate(async (valid) => {
        if (valid) {
          let [err, res] = [null, {}]
          if (this.config.type === 'add') {
            ;[err, res] = await cloudRenderNodesApi.create({
              body: this.operateForm,
            })
          } else if (this.config.type === 'edit' && this.currentId) {
            ;[err, res] = await cloudRenderNodesApi.update(this.currentId, {
              body: { ...this.operateForm, id: this.currentId },
            })
          }
          if (!err) {
            this.$message.success('保存成功')
            this.$emit('operateSuccess')
            this.close()
          }
        }
      })
    },
    // 关闭弹框
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-input-number--small {
  width: 440px !important;
}

::v-deep .el-input.is-disabled .el-input__inner {
  color: #000;
}
</style>
